import { Link } from 'react-router-dom';
import ListErrors from './ListErrors';
import React from 'react';
import agent from '../agent';
import { connect } from 'react-redux';
import Toggle from 'react-toggle'
import Loading from './widgets/Loading'
import {
    CHAT_CHANNEL_UPDATE_LOADED,
    CHAT_CHANNEL_UPDATE,
    CHAT_CHANNEL_UPDATE_UNLOADED,
    CHAT_CHANNEL_DELETE
} from '../constants/actionTypes';

const mapStateToProps = state => ({
    ...state.chat,
    currentUser: state.common.currentUser
});

const mapDispatchToProps = dispatch => ({
    onLoad: payload =>
        dispatch({ type: CHAT_CHANNEL_UPDATE_LOADED, payload }),
    onSubmit: (key, title, language) => {
        const payload = agent.Chats.updateChannel(key, title, language);
        dispatch({ type: CHAT_CHANNEL_UPDATE, payload })
    },
    onUnload: () =>
        dispatch({ type: CHAT_CHANNEL_UPDATE_UNLOADED }),
    onDelete: (payload) =>
        dispatch({ type: CHAT_CHANNEL_DELETE, payload }),
});

class ChannelEdit extends React.Component {
    constructor() {
        super();
        this.state = {
            title: '',
            language: '',
        }
        this.updateState = field => ev => {
            const state = this.state;
            const newState = Object.assign({}, state, { [field]: ev.target.value });
            this.setState(newState);
        }
        this.submitForm = (title, language) => ev => {
            ev.preventDefault();
            this.props.onSubmit(this.props.match.params.key, title, language);
        }
        this.delete = () => ev => {
            ev.preventDefault()
            const payload = agent.Chats.deleteChat(this.props.match.params.key)
            this.props.onDelete(payload)
        }
    }
    componentWillMount() {
        this.props.onLoad(agent.Chats.chatDetail(this.props.match.params.key, 0, '', '', ''));
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.channel) {
            Object.assign(this.state, {
                title: nextProps.channel.title,
                language: nextProps.channel.language,
            })
        }
    }
    componentWillUnmount() {
        this.props.onUnload();
    }
    handleChange(key, event) {
        this.setState({ [key]: event.target.checked })
    }
    render() {
        if (!this.props.channel) {
            return (
                <Loading />
            )
        }
        const title = this.state.title;
        const language = this.state.language;

        return (
            <div class='pane'>
                <Link className="crumb" to="/channels">&laquo; back to chat channels</Link>
                <h1>Update channel</h1>
                <ListErrors errors={this.props.errors} />
                <form onSubmit={this.submitForm(title, language)}>
                    <fieldset className="form">
                        <strong>Title</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="Title"
                                value={title}
                                onChange={this.updateState('title')} />
                        </fieldset>

                        <strong>Language</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="en"
                                value={language}
                                onChange={this.updateState('language')} />
                        </fieldset>
                        <fieldset className="form-group">
                            <button
                                type="submit"
                                disabled={this.props.inProgress}>
                                Update
                            </button>
                            <button
                                type="button"
                                onClick={this.delete()}
                                disabled={this.props.inProgress}>
                                Delete
                            </button>
                        </fieldset>
                    </fieldset>
                </form>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChannelEdit);



// WEBPACK FOOTER //
// ./src/components/ChannelEdit.js